<template>
    <div class="modal" :id="'editUserColorModal' + parentId" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-white p-3">
                    <h5 class="modal-title text-teal font-medium">Edit Color ( {{ selectedUser ? selectedUser.name : '' }} )</h5>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group row" v-if="selectedUser">
                        <label class="col-md-4 col-form-label text-md-right">
                            Color
                        </label>

                        <div class="col-md-6 flex content-center">
                            <colorpicker v-model="selectedColor"></colorpicker>
                        </div>

                    </div>
                </div>
                <div class="modal-footer bg-white p-2">
                    <button type="button" class="btn btn-outline-secondary mx-2" @click="close">Close</button>
                    <button type="button" class="btn btn-outline-primary mx-2" @click="updateUserColor">Update</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Colorpicker from "../../../../shared/colorpicker.vue";

export default {
    name: "edit-user-color-modal",
    components: {Colorpicker},
    props: ['parentId'],
    data() {
        return {
            selectedUser: null,
            selectedColor: null,
            selectedTeamId: null
        }
    },
    methods: {
        open(user, teamId) {
            this.selectedUser = user;
            this.selectedColor = user.color;
            this.selectedTeamId = teamId;
            $("#editUserColorModal" + this.parentId).modal("show");
        },
        close() {
            this.selectedUser = null;
            this.selectedColor = null;
            this.selectedTeamId = null;
            $("#editUserColorModal" + this.parentId).modal("hide");
        },
        updateUserColor() {
            let self = this;

            axios.post('/settings/'+this.selectedTeamId+'/members/update/user-team-color', {
                userId: self.selectedUser.id,
                teamId: self.selectedTeamId,
                color: self.selectedColor,
            }).then((response) => {
                self.getToast().fire({
                    type: 'success',
                    title: 'User color updated successfully!'
                });
                self.close();
            });
        }
    }
}
</script>

<style scoped>

</style>
